import { render, staticRenderFns } from "./SettingCreate.vue?vue&type=template&id=2182709c&scoped=true&"
import script from "./SettingCreate.vue?vue&type=script&lang=js&"
export * from "./SettingCreate.vue?vue&type=script&lang=js&"
import style0 from "./SettingCreate.vue?vue&type=style&index=0&id=2182709c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182709c",
  null
  
)

export default component.exports